import OPE from 'js/on-page-editing';

import { IQuote } from 'source/NFR.types';

const Quote: React.FC<IQuote> = ({ onPageEditing, text, quoteBy }) => (
  <blockquote>
    <span>“</span>
    <p {...OPE(onPageEditing?.text)}>{text}</p>
    <cite {...OPE(onPageEditing?.quoteBy)}>{quoteBy}</cite>
  </blockquote>
);

Quote.displayName = 'Quote';

export default Quote;
